
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h25v15H0z"}}),_c('g',{attrs:{"fill":"#CE1124"}},[_c('path',{attrs:{"d":"M11 0h3v15h-3z"}}),_c('path',{attrs:{"d":"M0 6h25v3H0z"}})])])
          )
        }
      }
    